import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { environment } from '../../../../environments/environment'
import { NumberSequence } from './number-sequence'

@Injectable({
  providedIn: 'root',
})
export class NumberSequenceService extends RestClientPaged<NumberSequence, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const httpClient = inject(HttpClient)
    super(environment.apiPath + '/sequencing/numbers', httpClient)
  }
}
